import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.editor.item');
import { OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let WizRoute: any;

@Component({
    selector: 'wiz-page-editor-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.editor.item/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageEditorItemComponent implements OnInit, OnDestroy {
    @ViewChild('chatMessagesContainer') chatMessagesEl: ElementRef;

    public dataReady: boolean = false;
    public presentation: any = null;
    public slides: any[] = [];
    public selectedSlideIndex: number = 0;
    public currentSlide: any = null;
    public chatMessages: any[] = [];
    public chatInput: string = '';
    public generating: boolean = false;
    public exporting: boolean = false;
    public statusMessage: string = '';

    // Template modal
    public showTemplateModal: boolean = false;
    public templates: any[] = [];
    public templateUploading: boolean = false;

    // IME composition state
    public isComposing: boolean = false;

    private presentationId: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public safeIterable(value: any, label: string): any[] {
        if (Array.isArray(value)) return value;
        return [];
    }

    private async safeRender(location: string) {
        try {
            await this.service.render();
        } catch (e) {
            console.error(`[render-error] at ${location}:`, e);
        }
    }

    public async ngOnInit() {
        await this.service.init();

        this.presentationId = WizRoute.segment.id;
        if (!this.presentationId) {
            this.service.href("/");
            return;
        }

        await this.load();
    }

    ngOnDestroy() { }

    private normalizeSlides(slides: any): any[] {
        if (!Array.isArray(slides)) {
            if (typeof slides === 'string') {
                try { slides = JSON.parse(slides); } catch { return []; }
                if (!Array.isArray(slides)) return [];
            } else {
                return [];
            }
        }
        return slides.filter((s: any) => s != null).map((s: any) => ({
            ...(typeof s === "object" ? s : {}),
            elements: Array.isArray(s.elements) ? s.elements : []
        }));
    }

    public async load() {
        let res = await wiz.call("get", { id: this.presentationId });
        if (res.code !== 200) {
            await this.service.modal.error("프레젠테이션을 찾을 수 없습니다.");
            this.service.href("/");
            return;
        }

        this.presentation = res.data;
        this.slides = this.normalizeSlides(this.presentation.slides_data);
        if (this.slides.length === 0) {
            this.slides = [{ layout: "Blank", elements: [{ type: "title", text: this.presentation.title }] }];
        }

        this.selectedSlideIndex = 0;
        const slide = this.slides[0] || null;
        if (slide && !Array.isArray(slide.elements)) {
            slide.elements = [];
        }
        this.currentSlide = slide;

        // Load chat history
        let chatRes = await wiz.call("chat_history", { id: this.presentationId });
        if (chatRes.code === 200 && Array.isArray(chatRes.data?.messages)) {
            this.chatMessages = chatRes.data.messages.map((m: any) => ({
                ...m,
                displayContent: this.formatAssistantContent(m)
            }));
        } else {
            this.chatMessages = [];
        }

        this.dataReady = true;
        await this.safeRender('load:dataReady');
    }

    public trackByIndex(index: number): number {
        return index;
    }

    public getSafeElements(): any[] {
        if (!this.currentSlide || !Array.isArray(this.currentSlide.elements)) return [];
        return this.currentSlide.elements;
    }

    public async selectSlide(index: number) {
        this.selectedSlideIndex = index;
        const slide = this.slides[index] || null;
        if (slide && !Array.isArray(slide.elements)) {
            slide.elements = [];
        }
        this.currentSlide = slide;
        await this.safeRender('selectSlide');
    }

    public async addSlide() {
        this.slides.push({ layout: "Blank", elements: [{ type: "title", text: "새 슬라이드", left_pct: 5, top_pct: 30, width_pct: 90, height_pct: 20 }] });
        await this.selectSlide(this.slides.length - 1);
        await this.saveSlides();
    }

    public async deleteSlide(index: number, event: any) {
        event.stopPropagation();

        this.slides.splice(index, 1);
        if (this.slides.length === 0) {
            this.slides = [{ layout: "Blank", elements: [] }];
        }
        if (this.selectedSlideIndex >= this.slides.length) {
            this.selectedSlideIndex = this.slides.length - 1;
        }
        this.currentSlide = this.slides[this.selectedSlideIndex];
        await this.saveSlides();
        await this.safeRender('deleteSlide');
    }

    public async saveTitle() {
        await wiz.call("update", { id: this.presentationId, title: this.presentation.title });
    }

    public async saveSlides() {
        await wiz.call("update_slides", {
            id: this.presentationId,
            slides_data: JSON.stringify(this.slides)
        });
    }

    // ── 시각 속성 헬퍼 ──

    /** slide 배경 CSS */
    public getSlideBackground(slide: any): string {
        if (!slide?.background) return '#ffffff';
        if (slide.background.fill) return this.fillToCSS(slide.background.fill);
        if (slide.background.image) {
            const tid = slide.template_id || '';
            const url = `/wiz/api/${wiz.namespace}/template_image?template_id=${tid}&path=${encodeURIComponent(slide.background.image.path)}`;
            return `url('${url}') center/cover no-repeat`;
        }
        return '#ffffff';
    }

    /** fill 객체를 CSS 값으로 변환 */
    public fillToCSS(fill: any): string {
        if (!fill) return 'transparent';
        if (fill.type === 'solid') return fill.color || 'transparent';
        if (fill.type === 'gradient' && fill.stops?.length) {
            const stops = fill.stops.map((s: any) => `${s.color} ${s.position}%`).join(', ');
            return `linear-gradient(180deg, ${stops})`;
        }
        return 'transparent';
    }

    /** element의 배경색 CSS */
    public getElemBackground(elem: any): string {
        if (!elem.fill) return 'transparent';
        return this.fillToCSS(elem.fill);
    }

    /** element의 border CSS */
    public getElemBorder(elem: any): string {
        if (!elem.line) return 'none';
        const w = elem.line.width || 1;
        const c = elem.line.color || '#000000';
        return `${w}pt solid ${c}`;
    }

    /** element의 transform CSS */
    public getElemTransform(elem: any): string {
        if (!elem.rotation) return 'none';
        return `rotate(${elem.rotation}deg)`;
    }

    /** 이미지 URL 생성 */
    public getImageUrl(elem: any): string {
        if (!elem.image?.path) return '';
        const tid = this.currentSlide?.template_id || '';
        return `/wiz/api/${wiz.namespace}/template_image?template_id=${tid}&path=${encodeURIComponent(elem.image.path)}`;
    }

    /** 이미지 URL (슬라이드 지정) */
    public getImageUrlForSlide(slide: any, elem: any): string {
        if (!elem.image?.path) return '';
        const tid = slide?.template_id || '';
        return `/wiz/api/${wiz.namespace}/template_image?template_id=${tid}&path=${encodeURIComponent(elem.image.path)}`;
    }

    /** 슬라이드 이미지 URL (LibreOffice 렌더링) */
    public getSlideImageUrl(slide: any): string {
        if (!slide?.slide_image || !slide?.template_id) return '';
        return `/wiz/api/${wiz.namespace}/template_image?template_id=${slide.template_id}&path=${encodeURIComponent(slide.slide_image)}`;
    }

    /** 슬라이드 이미지 URL (특정 슬라이드) */
    public getSlideImageUrlFor(slide: any): string {
        if (!slide?.slide_image || !slide?.template_id) return '';
        return `/wiz/api/${wiz.namespace}/template_image?template_id=${slide.template_id}&path=${encodeURIComponent(slide.slide_image)}`;
    }

    /** 요소의 텍스트 컨테이너 스타일 (패딩, 수직정렬) */
    public getElemTextStyle(elem: any): any {
        const style: any = {};
        const scale = this.currentSlide?.scale_factor || 1;

        // 텍스트 프레임 마진 → CSS padding
        if (elem.margin_left) style['padding-left'] = (elem.margin_left * scale) + 'pt';
        if (elem.margin_right) style['padding-right'] = (elem.margin_right * scale) + 'pt';
        if (elem.margin_top) style['padding-top'] = (elem.margin_top * scale) + 'pt';
        if (elem.margin_bottom) style['padding-bottom'] = (elem.margin_bottom * scale) + 'pt';

        // 수직 정렬
        if (elem.vertical_align) {
            style['display'] = 'flex';
            style['flex-direction'] = 'column';
            if (elem.vertical_align === 'middle') style['justify-content'] = 'center';
            else if (elem.vertical_align === 'bottom') style['justify-content'] = 'flex-end';
            else style['justify-content'] = 'flex-start';
        }

        return style;
    }

    /** run의 스타일 객체 (폰트 크기 스케일링 포함) */
    public getRunStyle(run: any, elem?: any): any {
        const style: any = {};
        const scale = this.currentSlide?.scale_factor || 1;

        // 폰트 크기: run에 있으면 사용, 없으면 요소 기본값 사용
        let fontSize = run.font_size;
        if (!fontSize && elem) {
            fontSize = elem.default_font_size;
        }
        if (fontSize) {
            style['font-size'] = (fontSize * scale) + 'pt';
            style['line-height'] = '1.2';
        }

        // 색상: run에 있으면 사용, 없으면 요소 기본 색상
        if (run.color) {
            style['color'] = run.color;
        } else if (elem?.default_color) {
            style['color'] = elem.default_color;
        }

        if (run.bold) style['font-weight'] = 'bold';
        if (run.italic) style['font-style'] = 'italic';
        if (run.underline) style['text-decoration'] = 'underline';
        if (run.font_family) style['font-family'] = `"${run.font_family}", sans-serif`;
        return style;
    }

    /** paragraph 스타일 */
    public getParaStyle(para: any, elem?: any): any {
        const style: any = {};
        const scale = this.currentSlide?.scale_factor || 1;

        if (para.alignment) style['text-align'] = para.alignment;
        if (para.space_after) style['margin-bottom'] = (para.space_after * scale) + 'pt';
        if (para.space_before) style['margin-top'] = (para.space_before * scale) + 'pt';
        if (para.level) style['padding-left'] = (para.level * 18 * scale) + 'pt';

        // 줄간격
        if (para.line_spacing) {
            style['line-height'] = String(para.line_spacing);
        } else if (para.line_spacing_pt) {
            style['line-height'] = (para.line_spacing_pt * scale) + 'pt';
        }

        return style;
    }

    /** paragraph의 text-align */
    public getParaAlign(para: any): string {
        return para.alignment || 'left';
    }

    /** 요소가 리치 텍스트(paragraphs)를 가지는지 */
    public hasRichText(elem: any): boolean {
        return Array.isArray(elem.paragraphs) && elem.paragraphs.length > 0;
    }

    /** 요소를 렌더링해야 하는지 (빈 요소 필터링) */
    public shouldRenderElem(elem: any): boolean {
        if (elem.type === 'image' && elem.image) return true;
        if (elem.fill) return true;
        if (elem.line) return true;
        if (elem.text && elem.text.trim()) return true;
        if (this.hasRichText(elem)) {
            return elem.paragraphs.some((p: any) => p.text && p.text.trim());
        }
        if (elem.table_data) return true;
        return false;
    }

    // ── 썸네일 텍스트 ──

    public getSlideTextElements(slide: any): any[] {
        if (!slide || !Array.isArray(slide.elements)) return [];
        return slide.elements.filter((e: any) =>
            ['title', 'subtitle', 'body', 'textbox'].includes(e.type) && e.text
        ).slice(0, 3);
    }

    // Template Modal
    public async openTemplateModal() {
        this.showTemplateModal = true;
        await this.safeRender('openTemplateModal');
        await this.loadTemplates();
    }

    public async loadTemplates() {
        let res = await wiz.call("template_list");
        if (res.code === 200) {
            this.templates = Array.isArray(res.data.rows) ? res.data.rows : [];
        }
        await this.safeRender('loadTemplates');
    }

    public async onTemplateFileSelect(event: any) {
        const file = event.target.files[0];
        if (!file) return;
        event.target.value = '';

        if (!file.name.endsWith('.pptx')) {
            await this.service.modal.error("PPTX 파일만 업로드 가능합니다.");
            return;
        }

        this.templateUploading = true;
        await this.safeRender('onTemplateFileSelect:start');

        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('name', file.name.replace('.pptx', ''));

            const response = await fetch(`/wiz/api/${wiz.namespace}/template_upload`, {
                method: 'POST',
                body: formData
            });
            const res = await response.json();
            if (res.code === 200) {
                await this.loadTemplates();
            } else {
                await this.service.modal.error(res.data?.message || "업로드에 실패했습니다.");
            }
        } catch (e: any) {
            await this.service.modal.error("업로드 중 오류가 발생했습니다.");
        } finally {
            this.templateUploading = false;
            await this.safeRender('onTemplateFileSelect:finally');
        }
    }

    public async applyTemplate(tmpl: any) {
        try {
            let res = await wiz.call("template_apply", {
                id: this.presentationId,
                template_id: tmpl.id
            });
            if (res.code === 200) {
                this.showTemplateModal = false;
                if (res.data?.slides) {
                    this.slides = this.normalizeSlides(res.data.slides);
                    this.selectedSlideIndex = 0;
                    const slide = this.slides[0] || null;
                    if (slide && !Array.isArray(slide.elements)) slide.elements = [];
                    this.currentSlide = slide;
                }
                await this.safeRender('applyTemplate');
            }
        } catch (e) {
            console.error('applyTemplate error:', e);
        }
    }

    public async deleteTemplate(tmpl: any, event: any) {
        event.stopPropagation();
        if (!confirm(`"${tmpl.name}" 템플릿을 삭제하시겠습니까?`)) return;

        let res = await wiz.call("template_delete", { id: tmpl.id });
        if (res.code === 200) {
            await this.loadTemplates();

            // 현재 슬라이드가 삭제된 템플릿을 사용 중이면 초기화
            const usesTemplate = this.slides.some((s: any) => s.template_id === tmpl.id);
            if (usesTemplate) {
                this.slides = [{ layout: "Blank", elements: [{ type: "title", text: this.presentation.title || "새 프레젠테이션", left_pct: 5, top_pct: 30, width_pct: 90, height_pct: 20 }] }];
                this.selectedSlideIndex = 0;
                this.currentSlide = this.slides[0];
                await this.saveSlides();
                await this.safeRender('deleteTemplate:reset');
            }
        }
    }

    public getLayoutCount(tmpl: any): number {
        try {
            const meta = JSON.parse(tmpl.metadata || '{}');
            return (meta.layouts || []).length;
        } catch { return 0; }
    }

    // Chat
    public async onChatKeydown(event: any) {
        if (event.shiftKey) return;
        if (event.isComposing || this.isComposing) return;
        event.preventDefault();
        await this.sendChat();
    }

    public async sendChat() {
        if (!this.chatInput.trim() || this.generating) return;

        const message = this.chatInput.trim();
        this.chatInput = '';
        this.chatMessages.push({ role: 'user', content: message, displayContent: message });
        this.generating = true;
        await this.safeRender('sendChat:start');
        this.scrollChatBottom();

        try {
            const formData = new FormData();
            formData.append('id', this.presentationId);
            formData.append('message', message);

            const response = await fetch(`/wiz/api/${wiz.namespace}/chat`, {
                method: 'POST',
                body: formData
            });

            const reader = response.body!.getReader();
            const decoder = new TextDecoder();
            let buffer = '';
            let fullContent = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n\n');
                buffer = lines.pop() || '';

                for (const line of lines) {
                    if (line.startsWith('data: ')) {
                        try {
                            const event = JSON.parse(line.slice(6));
                            if (event.type === 'status') {
                                this.statusMessage = event.content;
                                await this.safeRender('sendChat:status');
                            } else if (event.type === 'token') {
                                this.statusMessage = '';
                                fullContent += event.content;
                                await this.safeRender('sendChat:token');
                                this.scrollChatBottom();
                            } else if (event.type === 'done') {
                                // chat/none 액션이면 슬라이드 업데이트 건너뛰기
                                if (event.action && event.action !== 'chat' && event.action !== 'none') {
                                    if (event.slides && event.slides.length > 0) {
                                        this.slides = this.normalizeSlides(event.slides);
                                        const focusIdx = event.focus_index || 0;
                                        this.selectedSlideIndex = focusIdx;
                                        const s = this.slides[focusIdx] || this.slides[0] || null;
                                        if (s && !Array.isArray(s.elements)) s.elements = [];
                                        this.currentSlide = s;
                                    }
                                }
                                this.chatMessages.push({
                                    role: 'assistant',
                                    content: fullContent,
                                    displayContent: event.message || '완료되었습니다.'
                                });
                            } else if (event.type === 'error') {
                                this.chatMessages.push({
                                    role: 'assistant',
                                    content: event.message,
                                    displayContent: event.message
                                });
                            }
                        } catch (e) { }
                    }
                }
            }
        } catch (e: any) {
            this.chatMessages.push({
                role: 'assistant',
                content: '오류가 발생했습니다: ' + (e.message || '알 수 없는 오류'),
                displayContent: '오류가 발생했습니다: ' + (e.message || '알 수 없는 오류')
            });
        }

        this.generating = false;
        this.statusMessage = '';
        await this.safeRender('sendChat:end');
        this.scrollChatBottom();
    }

    public async clearChat() {
        let confirmed = await this.service.modal.show({
            title: '대화 초기화',
            message: '모든 대화 기록을 삭제하시겠습니까?',
            action: '초기화',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;

        await wiz.call("clear_chat", { id: this.presentationId });
        this.chatMessages = [];
        await this.safeRender('clearChat');
    }

    public async exportPptx() {
        this.exporting = true;
        await this.safeRender('exportPptx:start');

        try {
            let res = await wiz.call("export", { id: this.presentationId });
            if (res.code === 200) {
                const link = document.createElement('a');
                link.href = `/wiz/api/${wiz.namespace}/download?id=${this.presentationId}`;
                link.download = (this.presentation.title || 'presentation') + '.pptx';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                await this.service.modal.error(res.data?.message || "내보내기에 실패했습니다.");
            }
        } catch (e: any) {
            await this.service.modal.error("내보내기 중 오류가 발생했습니다.");
        }

        this.exporting = false;
        await this.safeRender('exportPptx:end');
    }

    private formatAssistantContent(msg: any): string {
        if (msg.role !== 'assistant') return msg.content;
        try {
            const parsed = JSON.parse(msg.content);
            if (parsed.message) return parsed.message;
        } catch { }
        return msg.content;
    }

    private scrollChatBottom() {
        setTimeout(() => {
            if (this.chatMessagesEl?.nativeElement) {
                this.chatMessagesEl.nativeElement.scrollTop = this.chatMessagesEl.nativeElement.scrollHeight;
            }
        }, 50);
    }
}

export default PageEditorItemComponent;